/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.0.0
 */
import { createAction } from '../app/createAction';
import {
    LOAD_STORAGE_DATA_FINISH,
    LOAD_STORAGE_DATA_START,
    REMOVE_COOKIE_DATA,
    REMOVE_STORAGE_DATA_START,
    REMOVE_STORAGE_DATA_SUCCESS,
    SET_COOKIE_DATA,
    SET_LOCAL_STORAGE_DATA,
    SET_SESSION_STORAGE_DATA,
    SET_STORAGE_DATA_SUCCESS,
} from './storageConstants';
import { ILocalStorage, IStorageReducerState } from './storageReducer';
import {
    IRemoveCookiePayload,
    ISetCookiePayload,
    ISetSessionStorageDataPayload,
    TFinishLoadStorageDataAction,
    TLoadCookiesAction,
    TRemoveCookieAction,
    TRemoveStorageDataStartAction,
    TRemoveStorageDataSuccessAction,
    TSetCookieAction,
    TSetLocalStorageDataAction,
    TSetSessionStorageDataAction,
    TSetStorageDataSuccessAction,
} from './storageTypes';

/**
 * Cookie receiving event
 * @returns {TLoadCookiesAction}
 */
export const loadCookies = (): TLoadCookiesAction => createAction(LOAD_STORAGE_DATA_START);

export const setCookie = (payload: ISetCookiePayload): TSetCookieAction =>
    createAction(SET_COOKIE_DATA, payload);

export const storageRemoveCookie = (payload: IRemoveCookiePayload): TRemoveCookieAction =>
    createAction(REMOVE_COOKIE_DATA, payload);

/**
 * Successful load of cookies
 * @param payload - IStorageReducerState
 */
export const finishLoadStorageData = (payload: IStorageReducerState): TFinishLoadStorageDataAction => {
    return createAction(LOAD_STORAGE_DATA_FINISH, payload);
};

/**
 * The event of remove of the cookies
 */
export const removeStorageDataStart = (): TRemoveStorageDataStartAction => createAction(REMOVE_STORAGE_DATA_START);

/**
 * The event successfully remove the cookies from the local store
 * @returns {TRemoveStorageDataSuccessAction}
 */
export const removeStorageDataSuccess = (): TRemoveStorageDataSuccessAction =>
    createAction(REMOVE_STORAGE_DATA_SUCCESS);

/**
 * Action to write data to local storage
 * @param payload - ILocalStorage
 */
export const setLocalStorageDataAction = (payload: ILocalStorage): TSetLocalStorageDataAction =>
    createAction(SET_LOCAL_STORAGE_DATA, payload);

export const setSessionStorageData = (payload: ISetSessionStorageDataPayload): TSetSessionStorageDataAction =>
    createAction(SET_SESSION_STORAGE_DATA, payload);

export const setStorageDataSuccess = (): TSetStorageDataSuccessAction => createAction(SET_STORAGE_DATA_SUCCESS);
